import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import { SAVE_VISUALIZER } from '../../Queries';

import { IconSave, IconBed } from '../Icons';
import ShareDropdown from '../ShareDropdown/ShareDropdown';

import useWindowWidth from '../../hooks/useWindowWidth';
import { saveVisualizer, getTitleFromQueryParams, getVisualizerNoun } from '../../Utils/VisualizerUtils';

import { StyledBedTitle, StyledButtonList, StyledUpdateButton } from './VisualizerSaveStyles';

var _ref2 = React.createElement(IconBed, null);

var _ref3 = React.createElement(IconSave, null);

var _ref4 = React.createElement(IconSave, null);

var VisualizerSave = function VisualizerSave(_ref) {
  var user = _ref.user,
      toggleSaveModal = _ref.toggleSaveModal,
      toggleAccountModal = _ref.toggleAccountModal,
      queryParams = _ref.queryParams,
      selectedProducts = _ref.selectedProducts,
      _ref$topSection = _ref.topSection,
      topSection = _ref$topSection === undefined ? false : _ref$topSection;

  var _useMutation = useMutation(SAVE_VISUALIZER),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      saveVisualizerMutation = _useMutation2[0];

  var _useState = useState({
    updating: false,
    text: 'Update'
  }),
      _useState2 = _slicedToArray(_useState, 2),
      updateState = _useState2[0],
      setUpdateState = _useState2[1];

  var visualizerTitle = getTitleFromQueryParams(queryParams, user);
  var windowWidth = useWindowWidth();

  var _useContext = useContext(ThemeContext),
      mobileWidth = _useContext.mobileWidth;

  var handleUpdateClick = function handleUpdateClick() {
    setUpdateState(Object.assign({}, updateState, {
      updating: true
    }));
    saveVisualizer({
      saveVisualizerMutation: saveVisualizerMutation,
      queryParams: queryParams,
      title: visualizerTitle,
      selectedProducts: selectedProducts,
      onSuccessFunc: function onSuccessFunc() {
        return setUpdateState({
          updating: false,
          text: 'Updated!'
        });
      }
    });
  };

  var handleBlur = function handleBlur() {
    if (updateState.text === 'Updated!') {
      setUpdateState(Object.assign({}, updateState, {
        text: 'Update'
      }));
    }
  };

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      StyledButtonList,
      { useButtonStyling: !topSection },
      topSection && user && user.visualizers.length > 0 && React.createElement(
        'a',
        { href: '/account' },
        _ref2,
        (windowWidth > parseInt(mobileWidth) ? 'View ' : '') + 'Saved ' + getVisualizerNoun() + 's'
      ),
      React.createElement(ShareDropdown, {
        relativeUrl: window.location.pathname + window.location.search,
        selectedProducts: selectedProducts
      }),
      visualizerTitle ? // working on saved visualizer
      React.createElement(
        StyledUpdateButton,
        {
          onClick: handleUpdateClick,
          onBlur: handleBlur,
          isUpdating: updateState.updating
        },
        _ref3,
        updateState.text
      ) :
      // working on new visualizer
      React.createElement(
        'button',
        {
          onClick: window.Dormify.customerId !== '' ? toggleSaveModal : function () {
            return toggleAccountModal({
              active: true,
              formType: 'LOGIN'
            });
          }
        },
        _ref4,
        'Save'
      )
    ),
    topSection && visualizerTitle && React.createElement(
      StyledBedTitle,
      null,
      visualizerTitle
    )
  );
};

VisualizerSave.propTypes = {
  toggleSaveModal: PropTypes.func.isRequired,
  toggleAccountModal: PropTypes.func.isRequired,
  queryParams: PropTypes.string,
  user: PropTypes.object,
  selectedProducts: PropTypes.array.isRequired,
  topSection: PropTypes.bool
};

export default VisualizerSave;